import { ActionTypes } from "./constants";

const initialState = {
  data: [],
};

const MgtOrgReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_ORG:
      return { ...state, data: payload };
    case ActionTypes.ADD_ORG:
      return { ...state, data: [...state.data, payload] };
    case ActionTypes.UPDATE_ORG:
      return {
        ...state,
        data: state.data.map((d) => (d.id == payload.id ? payload : d)),
      };
    case ActionTypes.DELETE_ORG:
      return {
        ...state,
        data: state.data.filter((d) => d.id != payload.id),
      };
    default:
      return state;
  }
};

export default MgtOrgReducer;
